import { jsx as _jsx } from "react/jsx-runtime";
var FileTextOutline = function FileTextOutline(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.99988 9.33337H5.99988C5.63188 9.33337 5.33321 9.03471 5.33321 8.66671C5.33321 8.29871 5.63188 8.00004 5.99988 8.00004H7.99988C8.36788 8.00004 8.66655 8.29871 8.66655 8.66671C8.66655 9.03471 8.36788 9.33337 7.99988 9.33337ZM5.33321 11.3334C5.33321 10.9654 5.63188 10.6667 5.99988 10.6667H9.99988C10.3685 10.6667 10.6665 10.9654 10.6665 11.3334C10.6665 11.7014 10.3685 12 9.99988 12H5.99988C5.63188 12 5.33321 11.7014 5.33321 11.3334ZM11.6294 13.3334H4.37008C4.16608 13.3334 4.00008 13.184 4.00008 13V3.00004C4.00008 2.81604 4.16608 2.66671 4.37008 2.66671H8.00008V4.76671C8.00008 5.81471 8.81141 6.66671 9.80941 6.66671H12.0001V13C12.0001 13.184 11.8341 13.3334 11.6294 13.3334ZM9.33342 3.31871L11.1614 5.33337H9.80942C9.54675 5.33337 9.33342 5.07937 9.33342 4.76671V3.31871ZM13.1601 5.55204L9.53075 1.55204C9.40408 1.41271 9.22542 1.33337 9.03675 1.33337H4.37008C3.43075 1.33337 2.66675 2.08137 2.66675 3.00004V13C2.66675 13.9187 3.43075 14.6667 4.37008 14.6667H11.6294C12.5687 14.6667 13.3334 13.9187 13.3334 13V6.00004C13.3334 5.83404 13.2714 5.67471 13.1601 5.55204Z",
      fill: color
    })
  });
};
export default FileTextOutline;